import { LoginUrlsWrapper } from '../../app/spaces/Login/LoginUrls';
import { ResultHelper } from '../helpers/ResultHelper';
import { Module } from '../Module';
import {
  IPKCEGetAuthorizationCodeResult,
  PKCEGetAuthorizationCodeRequest,
} from '../ServerApi/requests/PKCEGetAuthorizationCodeRequest';
import { PKCEService } from '../services/PKCEService';
import { ServerService } from '../services/ServerService';
import { WindowLocationService } from '../services/WindowLocationService';

export interface IPKCEGetAuthorizationCodeCtrlStateParams {
  appUriProtocol?: string;
  codeChallenge?: string;
  codeChallengeMethod?: string;
}

export interface IPKCEGetAuthorizationCodeCtrlScope extends ng.IScope {
  appUriProtocol: string;
  proceed: () => void;
  rememberMyChoice: {value: boolean};
  signingIn: boolean;
}

export class PKCEGetAuthorizationCodeCtrl {

  private static KNOWN_APP_URI_PROTOCOLS = ['tableau'];
  private static KNOWN_APP_URI_PROTOCOLS_STORAGE_KEY = 'PKCE.knownAppUriProtocols';

  public static $inject = [
    '$q',
    '$location',
    '$scope',
    '$stateParams',
    'ServerService',
    'WindowLocationService',
    'PKCEService',
  ];

  constructor(
    $q: ng.IQService,
    $location: ng.ILocationService,
    $scope: IPKCEGetAuthorizationCodeCtrlScope,
    $stateParams: IPKCEGetAuthorizationCodeCtrlStateParams,
    ServerService: ServerService,
    WindowLocationService: WindowLocationService,
    PKCEService: PKCEService
  ) {

    function isAppUriProtocolKnown(value: string): Promise<boolean> {
      if (PKCEGetAuthorizationCodeCtrl.KNOWN_APP_URI_PROTOCOLS.indexOf(value) >= 0) {
        return Promise.resolve(true);
      } else {
        return PKCEService.getLocalStorage(PKCEGetAuthorizationCodeCtrl.KNOWN_APP_URI_PROTOCOLS_STORAGE_KEY).then((stored: string[]) => {
          if (stored === null) {
            return false;
          } else {
            return stored.indexOf(value) >= 0;
          }
        });
      }
    }

    function addKnownAppUriProtocol(value: string): Promise<void> {
      return PKCEService.getLocalStorage(PKCEGetAuthorizationCodeCtrl.KNOWN_APP_URI_PROTOCOLS_STORAGE_KEY).then((stored: string[]) => {
        if (stored == null) {
          stored = [value];
        } else if (stored.indexOf(value) < 0) {
          stored.push(value);
        }
        return PKCEService.setLocalStorage(PKCEGetAuthorizationCodeCtrl.KNOWN_APP_URI_PROTOCOLS_STORAGE_KEY, stored);
      });
    }

    function supplyAuthorizationCodeToApp(): ng.IPromise<any> {
      const request = new PKCEGetAuthorizationCodeRequest({
        codeChallenge: $stateParams.codeChallenge,
        codeChallengeMethod: $stateParams.codeChallengeMethod,
      });
      $scope.signingIn = true;
      return ServerService.sendRequest(request)
        .then(ResultHelper.rejectResultOnError($q))
        .then((result: IPKCEGetAuthorizationCodeResult) => {
          const appUrl = $stateParams.appUriProtocol + '://pkce/login'
            + '?authorizationCode=' + result.authorizationCode
            + '&host=' + WindowLocationService.getHost();
          WindowLocationService.navigateTo(appUrl);
        });
    }

    if (ServerService.inSession()) {
      isAppUriProtocolKnown($stateParams.appUriProtocol).then((appUriProtocolKnown: boolean) => {
        if (appUriProtocolKnown) {
          supplyAuthorizationCodeToApp();
        } else {
          $scope.rememberMyChoice = {value: false};
          $scope.appUriProtocol = $stateParams.appUriProtocol;
          $scope.proceed = () => {
            if ($scope.rememberMyChoice.value) {
              addKnownAppUriProtocol($scope.appUriProtocol).then(() => supplyAuthorizationCodeToApp());
            } else {
              supplyAuthorizationCodeToApp();
            }
          };
        }
      });
    } else {
      LoginUrlsWrapper.navigateToSignIn({
        redirect: $location.url()
      });
    }
  }
}

Module.instance().controller('PKCEGetAuthorizationCodeCtrl', PKCEGetAuthorizationCodeCtrl);
